// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".observer[data-v-33b6b5b0] {\n  width: 100%;\n  height: 1px;\n}\n", ""]);
// Exports
module.exports = exports;
